import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=29aea578"
import script from "./Documentos.vue?vue&type=script&lang=js"
export * from "./Documentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29aea578')) {
      api.createRecord('29aea578', component.options)
    } else {
      api.reload('29aea578', component.options)
    }
    module.hot.accept("./Documentos.vue?vue&type=template&id=29aea578", function () {
      api.rerender('29aea578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/infoBase/Documentos.vue"
export default component.exports